import { render, staticRenderFns } from "./Etapa04.vue?vue&type=template&id=c8fba27c"
import script from "./Etapa04.vue?vue&type=script&lang=js"
export * from "./Etapa04.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports